import { cn } from '@/lib/utils';

type MaterialSymbolProps = {
  name: string;
  className?: string;
  /** 100–700 */
  weight?: number;
  /** 0 or 1 */
  fill?: 0 | 1;
  'aria-hidden'?: boolean | 'true' | 'false';
};

/**
 * Google Material Symbols Outlined — matches arcadia_design HTML mocks.
 * @see https://fonts.google.com/icons
 */
export function MaterialSymbol({
  name,
  className,
  weight = 400,
  fill = 0,
  'aria-hidden': ariaHidden = true,
}: MaterialSymbolProps) {
  return (
    <span
      className={cn('material-symbols-outlined inline-flex select-none', className)}
      style={{
        fontVariationSettings: `'FILL' ${fill}, 'wght' ${weight}, 'GRAD' 0, 'opsz' 24`,
      }}
      aria-hidden={ariaHidden === true || ariaHidden === 'true'}
    >
      {name}
    </span>
  );
}
